import React from 'react';
import styled from 'styled-components';
import { layout, media } from 'src/components/base';
import { Button } from 'src/components/button';
import { Translate } from 'src/components/translate';
import { Column, GridRow } from '@prisjakt/ui/list/variants';
import { applyFilterAreaHeight } from '../../constants';

type Props = {
  count?: number;
  hasFiltered?: boolean;
  onClick: () => void;
  onClear?: () => void;
  canClear?: boolean;
};

const ApplyFilterButton = ({
  count = 0,
  hasFiltered = true,
  onClick,
  onClear,
  canClear = true,
}: Props) => (
  <ActionBar>
    <Column gap={parseFloat(layout.measurements.spacing050)}>
      <ProductCount>
        <Translate domain="filter" n={count}>
          result.n-products
        </Translate>
      </ProductCount>
      <GridRow gap={parseFloat(layout.measurements.spacing050)}>
        {onClear && (
          <Button
            color="tertiary"
            variant="outlined"
            onClick={onClear}
            disabled={!canClear}
          >
            <Translate domain="filter">button.clear-filter</Translate>
          </Button>
        )}
        <Button color="primary" onClick={onClick} disabled={!hasFiltered}>
          <Translate domain="filter">button.apply-filter</Translate>
        </Button>
      </GridRow>
    </Column>
  </ActionBar>
);

export default ApplyFilterButton;

export const ActionBar = styled.div`
  background-color: ${p => p.theme.actionBar.bg};
  box-shadow: ${p => p.theme.actionBar.boxShadow};
  color: ${p => p.theme.actionBar.fg};
  width: 100%;
  padding: 10px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;

  /* Set explicit height in order to account for that height in the wrapper */
  height: ${applyFilterAreaHeight}px;

  ${media.largeUp`
    display: none;
  `}
`;

export const ProductCount = styled.div`
  text-align: center;
`;
